// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tripleToggleComponent {
  width: 100%;
}
.tripleToggleComponent .toggleLabel {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-bottom: 4px;
}
.tripleToggleComponent .tripleToggleContainer {
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #505054;
}
.tripleToggleComponent .tripleToggleContainer .option {
  text-align: center;
  width: 33.33%;
  padding-top: 15px;
}
.tripleToggleComponent .tripleToggleContainer .middle {
  border-left: 1px solid #e1e1e1;
  border-right: 1px solid #e1e1e1;
}
.tripleToggleComponent .tripleToggleContainer .left {
  border-radius: 8px 0px 0px 8px;
}
.tripleToggleComponent .tripleToggleContainer .right {
  border-radius: 0px 8px 8px 0px;
}
.tripleToggleComponent .tripleToggleContainer .selected {
  color: #ffffff;
  background: #4a515e;
}
.tripleToggleComponent .description {
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.tripleToggleComponent .description .icon {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/tripleToggleComponent/tripleToggleComponent.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AAAI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAER;AACI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AACR;AACQ;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;AACZ;AAEQ;EACI,8BAAA;EACA,+BAAA;AAAZ;AAEQ;EACI,8BAAA;AAAZ;AAEQ;EACI,8BAAA;AAAZ;AAGQ;EACI,cAAA;EACA,mBAAA;AADZ;AAII;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAGQ;EACI,iBAAA;AADZ","sourcesContent":[".tripleToggleComponent {\n    width: 100%;\n    .toggleLabel {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px; \n        color: #505054;\n        margin-bottom: 4px;\n    }\n\n    .tripleToggleContainer {\n        width: 100%;\n        height: 56px;\n        display: flex;\n        flex-direction: row;\n        border: 1px solid #e1e1e1;\n        border-radius: 8px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        text-align: center;\n        color: #505054;\n\n        .option {\n            text-align: center;\n            width: 33.33%;\n            padding-top: 15px;\n        }\n\n        .middle {\n            border-left: 1px solid #e1e1e1;\n            border-right: 1px solid #e1e1e1;\n        }\n        .left {\n            border-radius: 8px 0px 0px 8px;\n        }\n        .right {\n            border-radius: 0px 8px 8px 0px;\n        }\n\n        .selected {\n            color: #ffffff;\n            background: #4a515e;\n        }\n    }\n    .description {\n        display: flex;\n        flex-direction: row;\n        margin-top: 12px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n        .icon {\n            margin-right: 5px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
